export class DateFormatHelper {

    static date() {
        const now = new Date();
        const offsetMs = now.getTimezoneOffset() * 60 * 1000
        return {now, offsetMs};
    }

    static splitDateTime(datetimeStr?: string | null) {
        if(!datetimeStr) return undefined;
        const date = datetimeStr.slice(0, 10); // 'YYYY-MM-DD'
        const time = datetimeStr.slice(11, 16); // 'HH:MM'
        return { date, time };
    }


    
    static toInputDateTime(utcDate? : string | null) {
        const newDate = utcDate ? new Date(utcDate) : null;
        if(newDate) {
            return new Date(newDate.getTime() - this.date().offsetMs).toISOString().slice(0,16);
        }
        return "";
    }

    static toInput(date? : string | null) {
        return date? new Date(date).toISOString().split("T")[0] : "";
    }

    static toLocaleString = (date? : string | null) => {
        return date ? new Date(date).toLocaleString('fr-FR') : "";
    }

    static toLocaleDateString = (date? : string | null) => {
        return date ? new Date(date).toLocaleDateString('fr-FR') : "";
    }


    static fromFrenchDate(dateStr: string):number {
        if (typeof dateStr !== 'string') return 0;

        const [datePart, timePart = '00:00:00'] = dateStr.trim().split(' ');
        const [day, month, year] = datePart.split('/');

        if (!day || !month || !year) return 0;

        // Ex: "2025-06-30T10:00:00"
        const isoString = `${year}-${month}-${day}T${timePart}`;
        const date = new Date(isoString);
        const time = date.getTime();
        return isNaN(time) ? 0 : time;
    }

    
}